import { render, staticRenderFns } from "./ClaimReport.vue?vue&type=template&id=492a05f2&scoped=true"
import script from "./ClaimReport.vue?vue&type=script&lang=js"
export * from "./ClaimReport.vue?vue&type=script&lang=js"
import style0 from "./ClaimReport.vue?vue&type=style&index=0&id=492a05f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492a05f2",
  null
  
)

export default component.exports